module.exports = __webpack_public_path__ + "static/media/h_7_3_panning.97c3d9e9.gif";